import { WRAP_BRIDGE_API_HOST } from "../../config"
import { createSendRequest } from "../../utils/createSendRequest"
import { ApiPaths, paths } from "../wrapBridge/types"

export const sendRequest = createSendRequest<paths, typeof ApiPaths>(ApiPaths, {
  baseUrl: WRAP_BRIDGE_API_HOST,
})
